/**
 * @fileoverview 消息通知模块枚举定义
 * 
 * 对应后端文件：
 * - backend/app/Modules/Notification/Models/Notification.php
 * - backend/app/Modules/Notification/Models/NotificationChannel.php
 * 
 * 注意事项：
 * - 枚举值必须与后端常量完全一致（包括大小写）
 * - 所有枚举值都需要中文注释
 * 
 * 更新时机：
 * - 后端新增消息类型、级别、渠道时
 * - 后端修改枚举值时
 * 
 * 验证方式：
 * - 对照后端 Model 常量定义
 * - 确保枚举值完全匹配
 * 
 * @last-updated 2025-01-20
 */

/**
 * 消息类型枚举
 */
export enum NotificationType {
  /** 任务消息 */
  TASK = 'task',
  /** 告警消息 */
  ALERT = 'alert',
  /** 审批消息 */
  APPROVAL = 'approval',
  /** 系统消息 */
  SYSTEM = 'system',
  /** 订单消息 */
  ORDER = 'order',
  /** NCR 不合格品通知（对应后端 Notification::TYPE_NCR） */
  NCR = 'ncr',
  /** 班长日报消息（对应后端 Notification::TYPE_DAILY_REPORT） */
  DAILY_REPORT = 'daily_report',
}

/**
 * 消息级别枚举
 */
export enum NotificationLevel {
  /** 信息 */
  INFO = 'info',
  /** 警告 */
  WARNING = 'warning',
  /** 错误 */
  ERROR = 'error',
  /** 成功 */
  SUCCESS = 'success',
}

/**
 * 消息渠道枚举
 */
export enum NotificationChannel {
  /** 企业微信 */
  WECOM = 'wecom',
  /** App推送 */
  APP = 'app',
  /** Web推送 */
  WEB = 'web',
  /** 短信 */
  SMS = 'sms',
  /** 邮件 */
  EMAIL = 'email',
  /** 钉钉 */
  DINGTALK = 'dingtalk',
}

/**
 * 渠道状态枚举
 */
export enum ChannelStatus {
  /** 待发送 */
  PENDING = 'pending',
  /** 已发送 */
  SENT = 'sent',
  /** 发送失败 */
  FAILED = 'failed',
}

/**
 * 目标类型枚举
 */
export enum TargetType {
  /** 全部用户 */
  ALL = 'all',
  /** 部门 */
  DEPARTMENT = 'department',
  /** 指定用户 */
  USERS = 'users',
}
